<template>
    <iframe
        ref="iframe"
        :key="iframeKey"
        style="width: 100%; height: 100%; border: none;"
        :srcdoc="iframeContent"
        @load="resizeIframe($event.target)"
    ></iframe>
</template>



<script>
    export default {
        name: 'TipboxPreview',
        props: {
            config: {
                required: true,
                type: Object,
                validator(value) {
                    return value['data-bb-space-id'];
                },
            },
        },
        data() {
            return {
                tipboxScriptUrl: process.env.VUE_APP_TIPBOX_SCRIPT_URL || '',
                iframeKey: 0,
                resizeObserver: null,
            };
        },
        computed: {
            iframeContent() {
                const tagScript = 'script';
                const content = `
                    <!DOCTYPE html>
                    <html lang="pl">
                    <head>
                        <meta charset="UTF-8" />
                        <title>Tipbox Preview</title>
                        <style> /* Specyficzne style komponentu tutaj */ </style>
                    </head>
                    <body>
                        <div id="tipbox-object" type="text/html">
                        <div
                            id="tipbox-preview"
                            class="bb-widget"
                            data-bb-type="tipbox"
                            data-bb-preview="true"
                            ${this.generateConfigAttributes()}
                        ></div>
                        </div>
                        <${tagScript} src="${this.tipboxScriptUrl}"></${tagScript}>
                    </body>
                    </html>
                `;
                return content;
            },
        },
        watch: {
            config: {
                handler() {
                    this.updateTipbox();
                },
                deep: true,
            },
        },
        methods: {
            generateConfigAttributes() {
                return Object.entries(this.config)
                    .map(([key, value]) => ` ${key}="${value}"`)
                    .join('');
            },
            updateTipbox() {
                // Zwiększamy klucz iframe, aby wymusić jego ponowne renderowanie
                this.iframeKey += 1;
            },
            resizeIframe(iframe) {
                if (iframe?.contentWindow?.document?.documentElement) {
                    // eslint-disable-next-line no-param-reassign
                    iframe.style.minHeight = `${iframe.contentWindow.document.documentElement.scrollHeight}px`;
                }
            },
            handleResize() {
                this.resizeIframe(this.$refs.iframe);
            },
        },
        mounted() {
            this.resizeObserver = new ResizeObserver(this.handleResize);
            this.resizeObserver.observe(this.$refs.iframe);
        },
        beforeDestroy() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        },
    };
</script>
